export default __webpack_public_path__ + "static/media/KPI.142336aa.svg";